import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { updateSubmissionByKey } from '../actions';
import { FormGroup, ControlLabel } from 'react-bootstrap';

const MAX_YEARS_PA = 12;
const MAX_YEARS_DEFAULT = 10;

const styleProxy = new Proxy({}, { get: () => () => {} });

const customClassNames = {
  control: () => 'select-search-control',
  placeholder: () => 'select-search-placeholder',
  container: () => 'select-search-container',
  dropdownIndicator: ({ isFocused }) =>
    isFocused ? 'select-search-dropdown-indicator-focus' : 'select-search-dropdown-indicator',
  menu: () => 'select-search-menu',
  menuList: () => 'select-search-menu-list',
  valueContainer: () => 'select-search-value-container',
  indicatorsContainer: () => 'select-search-indicators-container',
  indicatorSeparator: () => 'select-search-indicator-separator',
  option: ({ isSelected, isFocused }) => {
    if (isSelected) return 'select-search-option-selected';
    if (isFocused) return 'select-search-option-focus';
    return 'select-search-option';
  },
  singleValue: () => 'select-search-single-value',
};

const AdditionalCoverageNumberInput = (props) => {
  const { submission, addlCoverageName, formKey, label, dispatch } = props;

  let additionalCoverage = {};
  if (
    submission?.coverages?.gl?.additional &&
    submission.coverages.gl.additional[addlCoverageName]
  ) {
    additionalCoverage = submission.coverages.gl.additional[addlCoverageName];
  }

  const isSelected = additionalCoverage.selected === true;
  const projectState = submission?.projectAddress?.projectState;
  const maxYears = projectState === 'Pennsylvania' ? MAX_YEARS_PA : MAX_YEARS_DEFAULT;
  const storedValue = submission?.optionalForms?.[formKey]?.numberOfYears;

  const yearOptions = Array.from({ length: maxYears }, (_, i) => ({
    value: i + 1,
    label: String(i + 1),
  }));

  const selectedOption = yearOptions.find((opt) => opt.value === storedValue) || null;

  useEffect(() => {
    if (!isSelected && submission?.optionalForms?.[formKey]?.numberOfYears !== undefined) {
      dispatch(
        updateSubmissionByKey({
          key: 'optionalForms',
          value: {
            ...submission.optionalForms,
            [formKey]: {},
          },
        })
      );
    }
  }, [isSelected, formKey, dispatch, submission.optionalForms]);

  const handleChange = (option) => {
    dispatch(
      updateSubmissionByKey({
        key: 'optionalForms',
        value: {
          ...submission.optionalForms,
          [formKey]: { numberOfYears: option ? option.value : '' },
        },
      })
    );
  };

  return (
    <div className="addlCoverageNumberInputContainer">
      <FormGroup>
        <ControlLabel>{label}</ControlLabel>
        <Select
          classNames={customClassNames}
          styles={styleProxy}
          options={yearOptions}
          value={selectedOption}
          onChange={handleChange}
          isDisabled={!isSelected}
          isSearchable={false}
          placeholder="Select..."
          unstyled
        />
      </FormGroup>
    </div>
  );
};

const mapStateToProps = (state) => ({
  submission: state.app.submission,
});

const connectedAdditionalCoverageNumberInput = connect(mapStateToProps)(AdditionalCoverageNumberInput);

export { connectedAdditionalCoverageNumberInput as AdditionalCoverageNumberInput };
